import type { BrandConfig } from './types';

export const defaultBrand: BrandConfig = {
  name: 'Wealthlane',
  primary: '#7B53D1',
  secondary: '#5BBCC9',
  accent: '#7B53D1',
  neutral: '#595959',
  fontFamily: '"HK Grotesk", sans-serif',
  monoFontFamily: '"JetBrains Mono", "Fira Code", ui-monospace, monospace',
  radius: 'sm',
};
